function isFilenameValid(filename) {
  // eslint-disable-next-line no-control-regex
  const invalidCharactersRegex = /[<>:/\\|?*\x00-\x1F;]/;
  return !invalidCharactersRegex.test(filename);
}

export default isFilenameValid;
